import { CommonService } from '@business/services';
import { Endpoint } from '../endpoint';
import { SignedURLResponse, UploadResponse } from '@business/entities/common';

export function upload(path: string, file: File, isPrivate: boolean = false) {
  const formData = CommonService.toFormData({ file, path, isPrivate });
  return Endpoint.post<UploadResponse>(`@gc/upload`, { formData, hasFiles: true });
}

export function video(url: string, options?: { autoplay: false }) {
  return Endpoint.post<{ embed: string; image: string }>(`@gc/upload/video`, { data: { url, ...options } });
}
export function getSignedUrl(url: string, isFilePath = false) {
  return Endpoint.post<SignedURLResponse>(`@gc/upload/signed-url`, { data: { url, isFilePath } });
}
